import { tz } from '@date-fns/tz';
import { format, parseISO } from 'date-fns';
import { enGB } from 'date-fns/locale/en-GB';

/**
 * English-locked "<Weekday>, DD Mon YYYY" for the given timezone (e.g.
 * `"Mon, 22 Jan 2026"`). Used by row-level cards where the weekday word
 * belongs to the copy, not the number-format decision. Deliberately not
 * locale-aware — the UI copy is English and the callers expect the same
 * shape regardless of `navigator.language`.
 *
 * @param {string | Date} datetime UTC ISO string or `Date`.
 * @param {string} [timezone] IANA zone; defaults to the browser's guessed zone.
 * @returns {string}
 */
export const formatWeekdayDate = (datetime, timezone) => {
	if (!datetime) return '';
	const parsed = typeof datetime === 'string' ? parseISO(datetime) : datetime;
	if (Number.isNaN(parsed?.getTime?.())) return '';

	const options = { locale: enGB };
	if (timezone) options.in = tz(timezone);
	return format(parsed, 'EEE, dd MMM yyyy', options);
};
